import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slider", "value"];

  connect() {
    if (this.hasSliderTarget && this.hasValueTarget) {
      this.updateValue();
      this.sliderTarget.addEventListener("input", this.updateValue.bind(this));
    }
  }

  updateValue() {
    const value = this.sliderTarget.value;
    const currency = this.sliderTarget.dataset.currency || "";
    this.valueTarget.textContent = `${currency} ${value}`;
  }
}
